export default __webpack_public_path__ + "static/monitoring-6201e335044cc51ab3cef420a4306b47.jpg";